import React from 'react';
import { RefreshCw, AlertTriangle } from 'lucide-react';

function ReparseConfirmModal({ onClose, onConfirm, docName }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
      <div className="w-full max-w-md p-6 rounded-lg bg-white dark:bg-card/95 shadow-xl border border-gray-400 dark:border-border/50">
        <div className="mb-4">
          <div className="flex items-center mb-3">
            <div className="size-8 rounded-full bg-orange-500/10 text-orange-500 flex items-center justify-center mr-3">
              <AlertTriangle className="h-4 w-4" />
            </div>
            <h2 className="text-lg font-semibold text-foreground">Re-parse Document?</h2>
          </div>
          <p className="text-sm text-gray-700 dark:text-muted-foreground">
            Are you sure you want to re-parse "<strong className="text-foreground">{docName}</strong>"? 
            This will process the document again and may take a few minutes.
          </p>
        </div>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-md border border-input bg-background hover:bg-muted transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 rounded-md bg-orange-600 text-white hover:bg-orange-700 transition-colors flex items-center"
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Re-parse
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReparseConfirmModal; 